import {post} from '../../shoptools/fetch';
import $ from 'jquery'; // TODO purge

export function bindResource (resource) {
  const html = document.documentElement;
  const $resource = $(resource);

  // submit form
  const submit = () => {
    const url = resource.getAttribute('action');
    const data = $resource.serialize();

    post(url, data).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.success) {
        resource.classList.add('added');
        resource.classList.remove('error');
      } else {
        // handle error
        resource.querySelector('.error').innerHTML = data.errors;
        resource.classList.add('error');
      }
    });
  };
  // bind keyup listener
  resource.addEventListener('click', (e) => {
    if (html.classList.contains('state-logged-in')) {
      // logged in
      // submit();
    } else {
      // not logged in
      e.preventDefault();
      resource.parentElement.classList.add('state-require-login');
    }
  });
}



// WEBPACK FOOTER //
// ./assets/j/src/collection/resources.js